import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Modal from '../Modal/Modal';
import { serverErrorPrettier } from '../../../utils/helpers';
import './ErrorModal.scss';

const propTypes = {
  visible: PropTypes.bool,
  className: PropTypes.string,
  error: PropTypes.string,
  requestClose: PropTypes.func,
  footer: PropTypes.node,
  children: PropTypes.node,
};
const errorIcon = require('./assets/ErrorIcon.png');

const defaultProps = {
  visible: false,
  className: '',
  error: '',
  requestClose: () => null,
  footer: null,
  children: null,
};
const renderFooter = (footer) => {
  if (footer) {
    return (
      <div className="footer-wrapper">{footer}
      </div>
    );
  }
  return null;
};
const renderBody = (children, prettyError) => {
  if (children) { return (children); }
  return (
    <React.Fragment>
      <div className="error-header">
        <span>{prettyError.header}</span>
      </div>  <div className="error-description" > <span>{prettyError.description}</span> </div>
    </React.Fragment>);
};


const ErrorModal = ({
  visible,
  className,
  error,
  requestClose,
  footer,
  children,
}) => {
  const modalClassNames = classNames({ 'error-modal-wrapper': true, [className]: true, visible });
  const prettyError = serverErrorPrettier(error);
  return (
    <Modal
      requestClose={requestClose}
      className={modalClassNames}
      visible={visible}
    >
      <div className="error-icon-wrapper">
        <img src={errorIcon} alt="triangle and mark" />
      </div>
      {renderBody(children, prettyError)}
      {renderFooter(footer)}

    </Modal>
  );
};

ErrorModal.propTypes = propTypes;
ErrorModal.defaultProps = defaultProps;

export default ErrorModal;



// WEBPACK FOOTER //
// ./src/components/_molecules/ErrorModal/ErrorModal.js